export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/seller_page_perseus/FiverrLearn.3c2d750.svg";